import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import parseQueryString from 'utils/parseQueryString';
import { navigateInternally } from 'utils/bolt';
import 'store/aspectRatioTrailer.js';
import 'store/customTracking.js';
// import s from 'base/bolt/boltApp.sss';
// import Store from 'store/store';

export default class BoltApp extends BaseComp.default {

	componentDidMount() {
		super.componentDidMount();
		// When demo password protection is on, we can add path to query string, and this will redirect to the right page once the password is successful
		// Just a quick workaround to avoid the 404 when trying to go directly to the path or having to share the path with secret string already in url
		// Store.on('SET_ACTIVE_PAGE', () => {
		// 	setTimeout(() => {
		// 		const page = Store.get().activePage;
		// 		if (page !== 'boltShowtimes') {
		// 			console.log("page: ", page)
		// 			const currentUrl = new URL(window.location);
		// 			currentUrl.searchParams.delete('format');
		// 			window.history.pushState({}, '', currentUrl);
		// 		}
		// 	}, 100);
		// });
		const qs = parseQueryString();
		const { path } = qs;
		if (!path) {
			return;
		}
		const pages = this.props.initialStore?.appData?.pages || {};
		const desiredPageId = Object.keys(pages).find(key => pages[key].path === `/${qs.path}/`);
		if (desiredPageId) {
			navigateInternally(desiredPageId);
			history.replaceState(null, '', location.pathname);
		}
	}
}
